<template>
 <ValidationObserver ref="formvalid" class="w-100">
  <div class="mb-4">
    <div ref="arrangementTable" class="container-table-striped w-100">
      <div class="table-hover">
        <table class="table content-table-striped table-striped mb-2">
          <thead>
            <tr class="row global-thead-dark thead-property">
              <th class="col-md-4">
                <span class="d-flex">Área</span>
              </th>
              <th class="col-md-8">
                <span class="d-flex">Acomodos</span>
              </th>
            </tr>
          </thead>

          <tbody
            v-if="arrangement.selected.length > 0 && !arrangement.isModified"
          >
            <tr
              v-for="(item, name) in arrangement.grouped"
              :key="name"
              class="row"
            >
              <td class="col-md-4 text-left">
                <div>
                  <b class="ml-3">
                    <span>{{ name }}</span>
                  </b>
                </div>
              </td>
              <td class="col-md-8 text-left">
                <BadgeTitle
                  v-for="x in item"
                  :key="x.arrangementId"
                  :class="'d-block'"
                  :title="parseArrangementName(x)"
                  :highlight="x.highlight"
                  :has-icon="!isDraft"
                  @delete="RemoveHandler(x)"
                />
              </td>
            </tr>
          </tbody>

          <tfoot>
            <tr
              v-if="
                arrangement.selected.length == 0 &&
                  arrangement.isModified == false &&
                  isDraft
              "
              class="w-100 text-center"
            >
              <button
                id="btnFA"
                class="btn bg-light-white w-50 pt-1 mt-3"
                @click="ModifyHandler()"
              >
                <i class="fas fa-file-plus pr-4 text-green" />
                <span class="text-button-add-document">
                  Presionar aquí para poder añadir acomodo
                </span>
              </button>
            </tr>
          </tfoot>
        </table>
      </div>
      <div v-if="arrangement.isModified == true">
        <div class="col-12 mb-2">
          <div class="row">
            <div class="col-4 pt-0">
              <div class="tag-badge">
                <span class="dot text-center pl-1">
                  <i class="fas fa-plus orange-icon orange-icon-badge-align" />
                </span>
                <span class="tag-badge-title py-1 pl-2">Añadir Acomodo</span>
              </div>
            </div>
            <div class="col-4 pt-0" />
            <div class="col-4 pt-0 d-flex justify-content-end">
              <span class="close-border p-1 mr-2 mt-0" @click="CloseHandler()">
                <i class="fas fa-window-close close-ico" />
                Cerrar
              </span>
            </div>
          </div>
        </div>

        <div class="col-12">
          <CustomDropDown
            v-model="selectedArea"
            placeholder="Seleccione área"
            label="Áreas:"
            fieldkey="id"
            fieldname="name"
            :options="areaList"
            class="w-50 mb-3"
            @input="FilterHandler()"
          />
        </div>

        <div class="col-12">
          <multiSelect
            :all-items="filteredArrangementItems"
            :item-type-name="'Objeto'"
            :selected-items="arrangement.temporary"
            :column-count="1"
            @itemSelected="OnItemSelectedHandler"
          />
        </div>
        <WarningBox
          class="ml-3 mt-3"
          title="Puede seleccionar uno(1) o más acomodos. Selección múltiple."
          inline
        />
        <div class="col-12">
          <h6 class="text-muted">
            Acomodos seleccionados
          </h6>
          <div class="panel">
            <BadgeTitle
              v-for="(item, index) in arrangement.temporary"
              :key="index"
              :title="item.arrangementName ? item.arrangementName : item.name"
              :highlight="item.highlight"
              :has-icon="!isDraft"
              @delete="RemoveHandler(item)"
            />
          </div>
        </div>
        <div class="col-2 my-2" v-if="canShowEnlargedFontSize">
          <validation-provider v-slot="{ errors }" rules="required">
          <custom-input              
              type="number"
              ref="enlargedFontSizeInput"
              v-model="model.enlargedFontSize"
              label="Tamaño Letra Agrandada:"             
              :min="1"
              :max="500"                          
              custom-error-msg="Favor documentar el tamaño de letra agrandada."              
              :error="errors[0]"
              @input="onInputEnlargedFontSize"
            />
        </validation-provider>
        </div>        
        <div class="text-right">
          <ActionButton
            class="btn btn-green success"
            i="fas fa-save"
            type="button"
            @click="SaveHandler()"
          >
            Guardar
          </ActionButton>
        </div>
      </div>

      <div
        v-if="
          arrangement.selected.length > 0 && !arrangement.isModified && isDraft
        "
      >
        <div class="text-right">
          <button
            class="btn p-1 btn-action btn-green btn-success-softer"
            @click="ModifyHandler()"
          >
            <span class="font-weight-light">
              <i class="fas fa-edit" />
              Modificar
            </span>
          </button>
        </div>
      </div>
    </div>
  </div>
   </ValidationObserver>
</template>

<script>
import mixAlert from '@/mixin/alert.mixin';
import mixWait from '@/mixin/loading.mixin';
import store from '@/store/index';
import multiSelect from '@/components/common/MultiSelectionPicker';
import CustomDropDown from '@/components/common/CustomDropDown';
import { BadgeTitle } from '@/components/pei/shared';
import { WarningBox } from '@/components/pei/tabs/components/tab8';
import ActionButton from '@/components/common/ActionButton';
import CustomInput from 'CustomInput';

const AREA_TO_FILTER = 1;
const MIN_FILTER_YEAR = 31;
const ARRANGEMENT_ITEM_TO_FILTER = 2223;
const ENLARGED_FONT = 437;

export default {
  name: 'LearningArrangement',
  mixins: [mixAlert, mixWait],
  components: {
    multiSelect,
    BadgeTitle,
    WarningBox,
    CustomDropDown,
    ActionButton,
    CustomInput
  },
  data() {
    return {
      Info: {},
      model: {
        enlargedFontSize: null
      },
      peiId: store.getters.SelectedPei,
      selectedArea: null,
    };
  },
  props: {
    arrangement: {
      type: Object,
      required: true,
    },
    areaList: {
      type: Array,
      required: true,
    },
    isDraft: {
      type: Boolean,
      required: true,
    },
  },
  computed: {
    filteredArrangementItems() {
      if (store.getters.getPeiInfo.academicYearId >= MIN_FILTER_YEAR && this.selectedArea?.id == AREA_TO_FILTER) {
        return this.arrangement?.items?.filter(x => x.id != ARRANGEMENT_ITEM_TO_FILTER) ?? [];
      }

      return this.arrangement?.items;
    },
    selectedGrouped() {
      let grouped_ = this.arrangement.selected.reduce((r, a) => {
        r[a.areaId] = [...(r[a.areaId] || []), a];
        return r;
      }, {});

      return grouped_;
    },
    canShowEnlargedFontSize(){          
      return this.arrangement.temporary.some(c=> c.arrangementId == ENLARGED_FONT || c.id == ENLARGED_FONT);
    }
  },
  methods: {
    ModifyHandler() {
      this.arrangement.isModified = true;
      
      if(this.arrangement.selected.some(x=> x.arrangementId == ENLARGED_FONT))
      {
        this.model.enlargedFontSize = this.arrangement.selected.find(x=> x.arrangementId == ENLARGED_FONT)?.enlargedFontSize;
      }

      this.arrangement.temporary = this.arrangement.selected.map((obj) => ({
        ...obj,
      }));
    },
    FilterHandler() {
      this.$emit('onFilterArrangement', this.selectedArea);
    },
    parseArrangementName(item)
    {    
      let nameParsed = item.arrangementName;

      if(item.arrangementId == ENLARGED_FONT)
      {      
        nameParsed = `${item.arrangementName}-${item.enlargedFontSize}`;
      }     

      return nameParsed;      
    },    
    async SaveHandler() {

      const isValid = await this.$refs.formvalid.validate();
      if (!isValid) {
        this.ShowToast(
          'Error',
          'Favor de completar la información solicitada.',
          'error'
        );
        return;
      }
      this.$emit('onSaveArrangement', this.model);
      this.ClearData();
    },
    RemoveHandler(item) {
      if (!item.arrangementId) {
        item.arrangementId = item.id;
      }
      this.$emit('onRemoveArrangement', item);
    },
    OnItemSelectedHandler(item) {
      if(item.id == ENLARGED_FONT)     
        this.model.enlargedFontSize = null;
      
      this.$emit('onItemSelectedArrangement', item);
    },
    CloseHandler() {
      this.$emit('fetchArrangement');
      this.ClearData();
    },
    ClearData() {
      this.arrangement.isModified = false;
      this.arrangement.items = [];
      this.selectedArea = null;
    },
    onInputEnlargedFontSize(value) {     
      const max = 500;
      const min = 1;
      const num = parseInt(value);
      if (isNaN(num)) {
        this.model.enlargedFontSize = '';
      } else if (num > max) {        
        this.model.enlargedFontSize = max;        
      } else if (num < min) {
        this.model.enlargedFontSize = min;
      } else {
        this.model.enlargedFontSize = num;
      }
     
      if (this.$refs.enlargedFontSizeInput?.$el?.querySelector('input')) {
        this.$refs.enlargedFontSizeInput.$el.querySelector('input').value = this.model.enlargedFontSize;
      }
    }
  },
};
</script>

<style scoped src="@/assets/css/component/panel-simple.css"></style>
<style scoped>
.close-border {
  border: 1px solid #2db782;
  border-radius: 50px;
  display: inline-block;
  font-family: 'Lato', sans-serif;
  font-weight: 400;
  font-size: 1.125rem;
  line-height: 1.6em;
  text-align: center;
  width: 7.1875rem;
  height: 2.6875‬rem;
  cursor: pointer;
  color: #2db782;
}

.close-ico {
  color: #2db782;
  margin-right: 3px;
}

.fa-times-circle {
  font-size: 18px;
  vertical-align: top;
}

.fa-orange {
  color: #ff7058;
}

.badge-orange {
  background-color: #ff7058;
  border: 1px solid #ff7058;
}

.badge-disable {
  background-color: transparent;
  border: 1px solid #b5c3bc;
  text-align: left;
  font: Regular 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
  opacity: 1;
}

.thead-property {
  box-shadow: 0px 3px 6px #00000029;
  border-radius: 5px 5px 0px 0px;
}

.title-section {
  text-align: left;
  font: Bold 16px/19px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.info-titule {
  margin-left: 17px;
  margin-top: -35px;
  margin-bottom: 20px;
  text-align: left;
  font: Bold 14px/17px Lato;
  letter-spacing: 0;
  color: #727272;
  opacity: 1;
}

.custompadding {
  padding: 1.2rem 0rem 1.2rem 2rem !important;
}
.list-group-item.text-center {
  background: #fafbfa !important;
  padding: 1rem !important;
}
.readonly {
  width: 210px !important;
  height: 40px !important;
}

.tag-badge {
  display: inline-block;
  padding-right: 1em;
  padding-bottom: 0.5%;
  background: transparent linear-gradient(90deg, #ffffff 0%, #e8e8e8 100%) 0% 0%
    no-repeat padding-box;
  border-radius: 26px;
  cursor: pointer;
}

.dot {
  width: 33px;
  height: 33px;
  border-radius: 50%;
  display: inline-block;
  opacity: 1;
  background: #ffffff 0% 0% no-repeat padding-box;
  box-shadow: 0px 3px 10px #00000029;
  padding-top: 7px;
}

.orange-icon {
  color: #ff7058;
  font-size: 15pt;
  padding-right: 4px;
  line-height: 23px;
}

.orange-icon-badge-align {
  vertical-align: top;
}

.tag-badge-title {
  text-align: left;
  font: Bold 18px/22px Lato;
  letter-spacing: 0;
  color: #11291b;
}

.alert-warning {
  background: #fff5e8 0% 0% no-repeat padding-box;
  border: 1px solid #fdac41;
  border-radius: 4px;
  opacity: 1;
}

.alert-icon {
  float: left;
  padding-top: 0.75%;
}

.alert-content {
  margin-left: 1.5%;
}

.alert span {
  text-align: left;
  font-family: 'Lato', sans-serif;
  font-size: 14px;
  font-weight: 400;
  letter-spacing: 0;
  color: #af6708;
  display: inline-grid;
}
</style>
